import $ from 'jquery';

export default function setupAutoUpdateLayoutElementsHeight() {
    $(window).on('DOMContentLoaded load resize scroll orientationchange', function () {
        //set height of navigation and settings block
        resizeHeight();
    });
}

export function resizeHeight() {
    let windowHeight = Math.floor($(window).height());

    const hosterContainer = $('#Hoster');

    const isEmbedded = (hosterContainer.length > 0);
    if (isEmbedded) {
        windowHeight = hosterContainer.height();
    }

    const headerHeight = Math.floor($('#header').innerHeight());
    const breadcrumbsHeight = ($('.header-breadcrumbs').css('display') === 'none') ? 0 : Math.floor($('.header-breadcrumbs').innerHeight());

    const footer = $('#footer');
    const footerHeight = footer.is(":hidden") ? 0 : footer.innerHeight();
    const mainBlockHeight = Math.floor($('.main-block').outerHeight(true));
    const documentHeight = footerHeight + headerHeight + breadcrumbsHeight + mainBlockHeight;

    let targetNavigationMenuHeight;
    if (documentHeight > windowHeight) {
        targetNavigationMenuHeight = windowHeight - (footerHeight + headerHeight + breadcrumbsHeight);
    } else {
        targetNavigationMenuHeight = windowHeight - (footerHeight + headerHeight + breadcrumbsHeight);
    }

    //set navigation block height
    if ($('.navigation-block').length) {
        const navigationToolbarHeight = Math.floor($('.navigation-toolbar').innerHeight());
        const searchBlock = Math.floor($('.navigation-search-block').innerHeight());
        const value2 = targetNavigationMenuHeight - navigationToolbarHeight;
        $('.navigation-menu-wrap.with-search').css('height', (value2 - searchBlock) + 'px');
        //set navigation search block height
        const value3 = value2 - 45;
        $('.navigation-search-results').css('height', value3 + 'px');
    }

    // set chosen-operators-list height
    if ($('.mi-chosen-operators-list').length) {
        const chosenOperatorsListRect = $('.mi-chosen-operators-list').get(0).getBoundingClientRect();
        const chosenOperatorsListHeight = windowHeight - chosenOperatorsListRect.top;

        if (chosenOperatorsListHeight > 0) {
            const bottomOffset = 15;
            $('.mi-chosen-operators-list').css({ 'max-height': `${chosenOperatorsListHeight - bottomOffset}px` });
        } else {
            $('.mi-chosen-operators-list').css({ 'max-height': 'initial' });
        }
    }
}
